import moment from "moment/moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const columns = () => {
  return [
    {
      title: '问卷标题',
      name: 'title',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '问卷类型',
      name: 'type',
      dict: [
        { code: 0, codeName: '普通问卷' },
        // { code: 2, codeName: '回执问卷' },
        { code: 3, codeName: '满意度问卷' },
      ],
      searchItem: {
        type: 'select',
      },
      tableItem: {}
    },
    {
      title: '问卷时间',
      name: 'surveyDate',
      // searchItem: {
      //   type: 'date~'
      // },
      tableItem: {
        render: (text, record) => {
          const { startDate, endDate } = record;
          const date = formatterDate(startDate) + " ~ " + formatterDate(endDate);
          return date
        },
      }
    },
    // {
    //   title: '状态',
    //   name: 'status',
    //   dict: [
    //     { code: 0, codeName: '草稿' },
    //     { code: 1, codeName: '已发布' },
    //     { code: 2, codeName: '已结束' },
    //     { code: 3, codeName: '已关闭' }
    //   ],
    //   searchItem: {
    //     type: 'select',
    //   },
    //   tableItem: {}
    // },

  ]
}

export default columns;
